import {
  GOOGLE_ANALYTICS_ID_STAGING,
  GOOGLE_TAG_MANAGER_ID_STAGING,
  META_PIXEL_ID,
} from '@env';

export const developmentConfig = {
  // Environment
  ENVIRONMENT: 'development',

  // API URL - Using local Docker backend
  API_URL: 'http://localhost:8000/api/v1',
  // API_URL: 'https://coloursense-api.onrender.com/api/v1',

  // Feature flags - Database is working, no need for mock mode
  MOCK_MODE: false,
  DEBUG_API: true,
  ENABLE_ANALYTICS: false,
  ENABLE_CRASH_REPORTING: false,

  // Google Analytics (shared with staging)
  GOOGLE_ANALYTICS_ID: GOOGLE_ANALYTICS_ID_STAGING,

  // Google Tag Manager (optional for development)
  GOOGLE_TAG_MANAGER_ID: GOOGLE_TAG_MANAGER_ID_STAGING,

  // Meta Pixel (optional for development)
  META_PIXEL_ID: META_PIXEL_ID,

  // Timeouts (in milliseconds) - increased for network requests
  TIMEOUTS: {
    API_REQUEST: 15000, // 15 seconds for deployed backend
    IMAGE_UPLOAD: 45000, // 45 seconds
    FILE_DOWNLOAD: 30000, // 30 seconds
  },

  // Logging
  LOG_LEVEL: 'debug',
  SHOW_DEV_WARNINGS: true,

  // Cache settings
  CACHE_TIMEOUT: 5000, // 5 seconds

  // Development specific settings
  ENABLE_HOT_RELOAD: true,
  ENABLE_REDUX_DEVTOOLS: true,
  ENABLE_PERFORMANCE_MONITORING: true,

  // Allow HTTP for deployed backend testing
  ALLOW_HTTP: false, // Use HTTPS for deployed backend
  DISABLE_SSL_VERIFICATION: false, // Use proper SSL for deployed backend

  // httpOnly cookie auth (web only) - reduces XSS risk; requires backend AUTH_USE_HTTPONLY_COOKIES=true
  USE_HTTPONLY_COOKIES:
    (process.env.EXPO_PUBLIC_USE_HTTPONLY_COOKIES || 'false').toLowerCase() ===
    'true',
};
